import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { formatDate } from "capitalrx-utilities";

import { DisplayField } from "../DisplayField";
import { MemberBaseType } from "../../interface";

export interface InformationPanelProps {
  eligibilityMemberData: MemberBaseType;
  isLoading: boolean;
}

const dateFormat = "MM/DD/YYYY";

export const InformationPanel: FC<InformationPanelProps> = ({ eligibilityMemberData, isLoading }) => {
  const { t: translate } = useTranslation();

  const { columns } = useResponsive({
    columns: {
      mobile: 12,
      tablet: 4,
      desktop: 4,
    },
  });

  return (
    <Stack>
      <Grid>
        <Grid.Span columns={columns}>
          <DisplayField title={translate("ELIGIBILITY.terminationDate")} isTitleSemibold isLoading={isLoading}>
            {formatDate(eligibilityMemberData?.termination_date, dateFormat) || "--"}
          </DisplayField>
        </Grid.Span>
        <Grid.Span columns={columns}>
          <DisplayField title={translate("ELIGIBILITY.hoursLastAdded")} isTitleSemibold isLoading={isLoading}>
            {formatDate(eligibilityMemberData?.hours_data?.hours_last_created_at, dateFormat) || "--"}
          </DisplayField>
        </Grid.Span>
        <Grid.Span columns={columns}>
          <DisplayField title={translate("ELIGIBILITY.reflectsWorkAsOf")} isTitleSemibold isLoading={isLoading}>
            {formatDate(eligibilityMemberData?.hours_data?.hours_last_updated_at, dateFormat) || "--"}
          </DisplayField>
        </Grid.Span>
      </Grid>

      <Grid>
        <Grid.Span columns={columns}>
          <DisplayField
            title={translate("ELIGIBILITY.ongoingEligibilityThreshold")}
            isTitleSemibold
            tooltip={translate("ELIGIBILITY.ongoingEligibilityThresholdTip")}
            isLoading={isLoading}
          >
            {eligibilityMemberData?.minimum_monthly_hours_for_eligibility ?? "--"}
          </DisplayField>
        </Grid.Span>
        <Grid.Span columns={columns}>
          <DisplayField
            title={translate("ELIGIBILITY.hoursBankedLimit")}
            isLoading={isLoading}
            isTitleSemibold
            tooltip={translate("ELIGIBILITY.hoursBankedLimitTip")}
          >
            {eligibilityMemberData?.maximum_hours_banked ?? "--"}
          </DisplayField>
        </Grid.Span>
        <Grid.Span columns={columns}>
          <DisplayField title={translate("ELIGIBILITY.hoursLastAdded")} isLoading={isLoading} isTitleSemibold>
            {formatDate(eligibilityMemberData?.hours_data?.hours_last_added_at, dateFormat) || "--"}
          </DisplayField>
        </Grid.Span>
      </Grid>
    </Stack>
  );
};
